module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/training-unit-lvl1-75.58c23848.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/training-unit-lvl1-75.png
// module id = 3563
// module chunks = 11